import React, { useState } from "react";
import axios from "axios";
import { contactUs } from "../../actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import contactUs123 from "../../assets/contactUs123.png";

const Contact = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    reasonForContact: "",
    context: "",
  });

  const imageURL = contactUs123;
  // Handle change for input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission (replace this with your backend logic)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      dispatch(contactUs(formData));
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Form submission failed. Please try again later.");
    }
  };

  return (
    <>
      <div
        className="flex flex-wrap items-center justify-center bg-white text-black xs:p-0 md:p-4 m-4"  
        style={{ fontFamily: "Gilroy-Medium" }}
      >
        {/* Image Section */}
        <div className="w-full md:w-1/3 p-3">
          <img src={imageURL} alt="ContactImg" className="w-full" />
        </div>

        {/* Form Section */}
        <div className="w-full md:w-2/3 md:p-4 xs:p-0 ">
          <div className="xs:p-0 m-3 xs:m-0">
            <h1 className="text-2xl mb-2 text-left font-bold">Contact Us</h1>
            <p className="text-left text-base mb-4">
              Fill out the form and we will contact you.{" "}
            </p>

            <form
              className="flex flex-col gap-4 items-start"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-row gap-3 w-full">
                {/* Full Name */}
                <div className="w-full flex flex-col">
                  
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                    className="p-2 border border-gray-300 rounded-lg text-base w-full"
                    placeholder="   Full Name*"
                  />
                </div>

                {/* Email */}
                <div className="w-full flex flex-col">
                 
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="p-2 border border-gray-300 rounded-lg text-base w-full"
                    placeholder="   Enter Your Email*"
                  />
                </div>
              </div>


              <div className="flex flex-row gap-3 w-full">
                {/* Phone Number */}
                <div className="w-full flex flex-col">
                  
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className="p-2 border border-gray-300 rounded-lg text-base w-full"
                    placeholder="   Phone Number*"
                  />
                </div>

                {/* Reason for Contact */}
                <div className="w-full flex flex-col">
                 
                  <select
                    id="reasonForContact"
                    name="reasonForContact"
                    value={formData.reasonForContact}
                    onChange={handleInputChange}
                    required
                    className="p-2 border border-gray-300 rounded-lg text-base w-full"
                    placeholder="   Reason for Contact*"
                  >
                    <option value="">Please select</option>
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Support">Support</option>
                    <option value="Partnership">Partnership</option>
                  </select>
                </div>
              </div>

              {/* Context */}
              <div className="w-full flex flex-col">
             
                <textarea
                  id="context"
                  name="context"
                  value={formData.context}
                  onChange={handleInputChange}
                  required
                  className="p-2 border border-gray-300 rounded-lg text-base w-full resize-y"
                  placeholder="   Type your message here*"
                />
              </div>
              <div>
                <p className="text-[12px] mb-0">By Clicking on “Send message” button you consent our Data Processing as per our Privacy Policy.</p>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="text-[10px] py-1 px-2 bg-pink-600 hover:bg-pink-800 text-white rounded text-base transition duration-300"
              >
                CONTACT US
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
